import { usePage } from '@inertiajs/react';
import React from 'react';
import { useSearch } from '../../hooks/useSearch';
import DriveSyncLayout from '../../layouts/DriveSyncLayout';
import CarriersHeader from './CarriersHeader';
import CarriersTable from './CarriersTable';

export default function Index() {
  const { props } = usePage();

  // Usar hook de pesquisa para transportadoras
  const {
    searchTerm,
    setSearchTerm,
    searchInputRef,
    filteredItems: filteredCarriers,
    hasSearch,
    totalResults,
    totalItems: totalCarriers
  } = useSearch(props.carriers, ['name', 'email', 'cnpj']);

  // Função para limpar busca
  const handleClearSearch = () => {
    setSearchTerm('');
  };

  return (
    <DriveSyncLayout>
      <CarriersHeader
        showAddButton
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        searchInputRef={searchInputRef}
        placeholder="Pesquisar..."
        totalResults={totalResults}
        totalCarriers={totalCarriers}
        hasSearch={hasSearch}
        onClearSearch={handleClearSearch}
      />
      <CarriersTable carriers={filteredCarriers} />
    </DriveSyncLayout>
  );
} 